import React, { useContext } from "react";
import { NavLink, Route } from "react-router-dom";
import { MarketContext } from "../../contexts/MarketContext";
import * as Icons from "../../icons";
import routes from "../../routes/sidebar";
import { Skeleton } from "../Skeleton/Skeleton";

interface IconProps {
    icon: string;
    className: string;
}

function Icon({ icon, ...props }: IconProps) {
    const Icon = Icons[icon as keyof typeof Icons];
    return <Icon {...props} />;
}

function SidebarContent() {
    const {
        state: { tikuPrice },
    } = useContext(MarketContext);

    return (
        <div className="py-4 text-gray-400">
            <span className="flex ml-6 p-2 text-lg font-bold text-gray-200">
                <img
                    alt="TIKU logo"
                    className="mr-2 w-12 h-12"
                    src={process.env.PUBLIC_URL + "/tiku-green.png"}
                />
                <span className="self-center">TIKU Rewards Center</span>
            </span>
            <div className="mt-2 flex justify-center">
                <span className="font-bold text-yellow-300 flex justify-center items-center">
                    TIKU $
                    {tikuPrice ? (
                        tikuPrice.toFixed(6)
                    ) : (
                        <Skeleton className="ml-1 w-16 h-6 bg-yellow-300" />
                    )}
                </span>
            </div>
            <ul className="mt-4">
                {routes.map((route) => (
                    <li className="relative px-6 py-3" key={route.name}>
                        <NavLink
                            exact
                            to={route.path}
                            className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-200"
                            activeClassName="text-gray-100"
                        >
                            <Route path={route.path}>
                                <span
                                    className="absolute inset-y-0 left-0 w-1 bg-green-600 rounded-tr-lg rounded-br-lg"
                                    aria-hidden="true"
                                ></span>
                            </Route>
                            <Icon className="w-5 h-5" aria-hidden="true" icon={route.icon} />
                            <span className="ml-4">{route.name}</span>
                        </NavLink>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default SidebarContent;
